export const SITE = {
  name: 'Oro Express Academy',
  shortName: 'Oro Express Academy',
  parent: 'Oro Express',
  tagline: 'Aprende a invertir en oro como un profesional',
  subTagline:
    '26 lecciones · Certificado de Oro Express · 100% gratis',
  bajada: 'La academia del oro de inversión',
  description:
    'Curso gratuito de inversión en oro físico de Oro Express. 26 lecciones rigurosas con certificado de Oro Express. Para inversores patrimoniales en España.',
  url: process.env.NEXT_PUBLIC_SITE_URL ?? 'http://localhost:6060',
  ogImage: '/opengraph-image',
  twitter: '@oroexpress_oficial',
  locale: 'es_ES',
  language: 'es',
} as const;

export const COMPANY = {
  name: process.env.NEXT_PUBLIC_COMPANY_NAME ?? 'Oro Express',
  legalName:
    process.env.NEXT_PUBLIC_COMPANY_LEGAL_NAME ?? 'Gold Center Capital, S.L.',
  cif: process.env.NEXT_PUBLIC_COMPANY_CIF ?? 'B76067560',
  address:
    process.env.NEXT_PUBLIC_COMPANY_ADDRESS ??
    'C. Fuente del Berro, 20, Local — 28009 Madrid, España',
  registry:
    process.env.NEXT_PUBLIC_COMPANY_REGISTRY ??
    'Registro Mercantil de Madrid, Tomo --, Folio --, Hoja M-------',
  phone: process.env.NEXT_PUBLIC_COMPANY_PHONE ?? '+34 900 907 797',
  whatsapp: process.env.NEXT_PUBLIC_COMPANY_WHATSAPP ?? '+34 636 20 79 21',
  schedule:
    process.env.NEXT_PUBLIC_COMPANY_SCHEDULE ??
    'Lunes a viernes, 9:00 - 21:00',
  email: process.env.NEXT_PUBLIC_COMPANY_EMAIL ?? 'info@oro-express.es',
  privacyEmail:
    process.env.NEXT_PUBLIC_PRIVACY_EMAIL ?? 'privacidad@oro-express.es',
  website:
    process.env.NEXT_PUBLIC_COMPANY_WEBSITE ?? 'https://oro-express.es',
} as const;

/**
 * Enlaces a las redes sociales oficiales y a las paginas clave del sitio
 * matriz https://oro-express.es. La academia es independiente, pero
 * referenciamos la matriz para que el alumno pueda saltar al ecommerce.
 */
export const SOCIAL = {
  instagram: 'https://www.instagram.com/oroexpress_oficial/',
  facebook: 'https://www.facebook.com/people/Oro-Express/61557019374697/',
  linkedin: 'https://www.linkedin.com/company/oro-express-sale-sl/',
  whatsapp: 'https://wa.me/34636207921',
} as const;

export const SOCIAL_LINKS = [
  {
    name: 'Instagram',
    handle: '@oroexpress_oficial',
    url: SOCIAL.instagram,
    icon: 'Instagram',
  },
  {
    name: 'Facebook',
    handle: 'Oro Express',
    url: SOCIAL.facebook,
    icon: 'Facebook',
  },
  {
    name: 'LinkedIn',
    handle: 'Oro Express',
    url: SOCIAL.linkedin,
    icon: 'Linkedin',
  },
  {
    name: 'WhatsApp',
    handle: '+34 636 20 79 21',
    url: SOCIAL.whatsapp,
    icon: 'MessageCircle',
  },
] as const;

/**
 * Paginas relevantes del sitio matriz oro-express.es. Las usamos para enlazar
 * desde el footer y CTAs cuando interesa derivar al ecommerce / tiendas.
 */
export const PARENT_SITE = {
  home: 'https://oro-express.es',
  shop: 'https://oro-express.es/tienda/',
  about: 'https://oro-express.es/sobre-nosotros/',
  contact: 'https://oro-express.es/contacto/',
  stores: 'https://oro-express.es/tiendas/',
  buyGoldStores: 'https://oro-express.es/tiendas-compro-oro/',
  buySilverStores: 'https://oro-express.es/tiendas-compro-plata/',
  faq: 'https://oro-express.es/preguntas-frecuentes/',
  privacy: 'https://oro-express.es/politica-de-privacidad/',
  cookies: 'https://oro-express.es/politica-de-cookies/',
  legalNotice: 'https://oro-express.es/aviso-legal/',
  terms: 'https://oro-express.es/terminos-y-condiciones/',
  bullion: 'https://oro-express.es/comprar-lingotes/',
  bullionGold: 'https://oro-express.es/comprar-lingotes/oro/',
  // URLs reales (verificadas contra la WC Store API). Apuntamos a la ficha SEMPSA
  // de cada gramaje para que el visitante vea precio + recompra directamente.
  bullionGold5g:
    'https://oro-express.es/producto/lingote-oro-5g-sempsa-espana/',
  bullionGold10g:
    'https://oro-express.es/producto/lingote-oro-10g-sempsa-espana/',
  bullionGold20g:
    'https://oro-express.es/producto/lingote-oro-20g-sempsa-espana/',
  bullionGold50g:
    'https://oro-express.es/producto/lingote-oro-50g-sempsa-espana/',
  bullionGold100g:
    'https://oro-express.es/producto/lingote-oro-100-gr-sempsa-espana/',
  bullionGold250g:
    'https://oro-express.es/producto/lingote-oro-250g-sempsa-espana/',
  bullionGold500g:
    'https://oro-express.es/producto/lingote-oro-500g-sempsa-espana/',
  bullionGold1kg:
    'https://oro-express.es/producto/lingote-oro-1kg-sempsa-espana/',
  bullionSilver: 'https://oro-express.es/comprar-lingotes/plata/',
  bullionPlatinum: 'https://oro-express.es/comprar-lingotes/platino/',
} as const;

export const NAV_LINKS = [
  { href: '/#programa', label: 'Programa' },
  { href: '/precio-oro', label: 'Precio del oro' },
  { href: '/glosario', label: 'Glosario' },
  { href: '/blog', label: 'Blog' },
  { href: '/faq', label: 'FAQ' },
] as const;

export const FOOTER_LINKS = {
  navigate: [
    { href: '/', label: 'Inicio' },
    { href: '/sobre-nosotros', label: 'Sobre nosotros' },
    { href: '/precio-oro', label: 'Precio del oro' },
    { href: '/glosario', label: 'Glosario' },
    { href: '/blog', label: 'Blog' },
    { href: '/faq', label: 'FAQ' },
  ],
  legal: [
    { href: '/legal/aviso-legal', label: 'Aviso legal' },
    { href: '/legal/politica-privacidad', label: 'Política de privacidad' },
    { href: '/legal/politica-cookies', label: 'Política de cookies' },
    { href: '/legal/terminos-uso', label: 'Términos de uso' },
    { href: '/legal/disclaimer-financiero', label: 'Disclaimer financiero' },
  ],
  account: [
    { href: '/login', label: 'Iniciar sesión' },
    { href: '/registro', label: 'Registrarse' },
    { href: '/dashboard', label: 'Mi cuenta' },
  ],
} as const;

export const TESTIMONIALS = [
  {
    name: 'Carlos M.',
    role: 'Empresario, Madrid',
    rating: 5,
    quote:
      'Llevaba meses comparando distribuidores. Oro Express me dio trazabilidad completa, certificado LBMA y un trato impecable. Repetiré seguro.',
    initial: 'CM',
  },
  {
    name: 'Lucía H.',
    role: 'Inversora particular, Valencia',
    rating: 5,
    quote:
      'Me asesoraron sin ninguna presión. Me explicaron las opciones de custodia y fiscalidad antes de tomar la decisión. Profesionalidad total.',
    initial: 'LH',
  },
  {
    name: 'Javier R.',
    role: 'Ingeniero, Barcelona',
    rating: 5,
    quote:
      'Compré mis primeras onzas con Oro Express y el proceso fue transparente de principio a fin. Envío asegurado y todo documentado.',
    initial: 'JR',
  },
  {
    name: 'Ana O.',
    role: 'Consultora financiera, Sevilla',
    rating: 5,
    quote:
      'Recomiendo Oro Express a mis clientes que quieren diversificar en oro físico. Seriedad, precios competitivos y atención personalizada.',
    initial: 'AO',
  },
  {
    name: 'Miguel Á.',
    role: 'Médico, Bilbao',
    rating: 5,
    quote:
      'Después de investigar mucho, elegí Oro Express por su transparencia. El lingote llegó con certificado de pureza y factura detallada. Muy satisfecho.',
    initial: 'MA',
  },
  {
    name: 'Patricia G.',
    role: 'Arquitecta, Málaga',
    rating: 5,
    quote:
      'Quería proteger parte de mis ahorros en oro y no sabía por dónde empezar. El equipo de Oro Express me guió paso a paso, sin prisas ni letra pequeña.',
    initial: 'PG',
  },
  {
    name: 'Fernando L.',
    role: 'Empresario, Zaragoza',
    rating: 5,
    quote:
      'Llevo dos años comprando oro de inversión con ellos. Siempre cumplen plazos, los precios son justos y la atención posventa es excelente.',
    initial: 'FL',
  },
  {
    name: 'Elena S.',
    role: 'Abogada, A Coruña',
    rating: 5,
    quote:
      'Lo que más valoro es la honestidad. Me explicaron cuándo no convenía comprar y eso generó mucha confianza. Un equipo con valores.',
    initial: 'ES',
  },
] as const;

export const FAQ_LANDING = [
  {
    q: '¿Es realmente gratis?',
    a: 'Sí, completamente. Las 26 lecciones, los quizzes y el certificado son 100% gratuitos. No hay tarjeta, ni periodo de prueba, ni letra pequeña. Es nuestra forma de aportar valor al sector y demostrar el rigor con el que trabaja Oro Express.',
  },
  {
    q: '¿Necesito conocimientos previos?',
    a: 'No. El curso está diseñado para arrancar desde cero. Si ya tienes experiencia en inversiones, los módulos 3, 4 y 5 te darán matices que probablemente no conozcas (fiscalidad, custodia profesional, asignación táctica).',
  },
  {
    q: '¿Cuánto tiempo me llevará?',
    a: 'Las 26 lecciones suman unas 8 horas de contenido. La mayoría de alumnos lo completa en 2-4 semanas, dedicando 30-60 minutos al día. Puedes ir a tu ritmo: el progreso se guarda automáticamente.',
  },
  {
    q: '¿Obtengo un certificado?',
    a: 'Sí. Al completar las 26 lecciones y aprobar los 7 quizzes finales y el examen final, obtienes el certificado de Oro Express en PDF (Oro Express Academy), con un ID único verificable públicamente.',
  },
  {
    q: '¿Tengo que comprar oro a Oro Express?',
    a: 'No. La academia es completamente independiente del proceso comercial. Aprenderás el marco general; si decides comprar, los asesores de Oro Express están disponibles, pero también puedes acudir a otros distribuidores certificados. La rigurosidad del contenido es la misma.',
  },
  {
    q: '¿Es asesoramiento financiero?',
    a: 'No. El contenido es exclusivamente educativo. No constituye asesoramiento financiero, fiscal o legal personalizado. Las decisiones de inversión deben tomarse considerando tu situación particular y siempre con un profesional cualificado.',
  },
  {
    q: '¿Puedo acceder desde el móvil?',
    a: 'Sí. La plataforma está optimizada para móvil, tablet y escritorio. El progreso se sincroniza entre dispositivos.',
  },
  {
    q: '¿Cómo se protege mi privacidad?',
    a: 'Cumplimos RGPD íntegramente. Solo solicitamos los datos imprescindibles (email, nombre opcional). Puedes ejercer tus derechos ARSULIPO en cualquier momento. Detalles completos en nuestra política de privacidad.',
  },
] as const;

export interface Stat {
  value: number;
  prefix?: string;
  suffix?: string;
  label: string;
}

export const STATS: readonly Stat[] = [
  {
    value: 5000,
    suffix: '+ años',
    label: 'Historia del oro como reserva de valor',
  },
  { value: 26, suffix: ' lecciones', label: 'Diseñadas con rigor académico' },
  { value: 87, prefix: '+', suffix: '%', label: 'Pérdida del USD desde 1971' },
  { value: 100, suffix: '%', label: 'Gratuito, sin tarjeta, sin compromiso' },
] as const;

export const VALUE_PROPS = [
  {
    title: 'Refugio contra la inflación',
    description:
      'El oro ha preservado el poder adquisitivo durante 124 años mientras el dólar perdía el 97% del suyo. La cobertura más probada de la historia.',
    icon: 'Shield',
  },
  {
    title: 'Activo tangible y líquido',
    description:
      'Físico, sin riesgo de contraparte, vendible en horas. Combina la solidez de lo tangible con la liquidez del mercado profesional.',
    icon: 'Diamond',
  },
  {
    title: 'Exento de IVA en España',
    description:
      'El oro de inversión cumple los requisitos de la Directiva 98/80/CE: cero IVA en compra. Una ventaja fiscal única entre los activos tangibles.',
    icon: 'BadgeCheck',
  },
  {
    title: 'Diversificación patrimonial',
    description:
      'Descorrelacionado con bolsa y bonos. Suaviza drawdowns y aporta resiliencia. Recomendado al 5-15% por gestores como Ray Dalio.',
    icon: 'PieChart',
  },
] as const;
